module.exports = __webpack_public_path__ + "img/blip_router_white.0d92b0c5.svg";